import React, { Component } from 'react'
import { connect } from 'react-redux'
import Markdown from "markdown-to-jsx"
import { Link } from 'react-router-dom'
import { fetchPosts } from "../actions/postActions"
import { Helmet } from "react-helmet"
import { Redirect } from 'react-router'
import loader from "../images/loader.svg"
import {
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from 'react-share';

class Post extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false
    };
  }
  componentDidMount() {
    document.getElementById("root").classList.remove("welcome");
    document.getElementById("foo").classList.add("overflow");
    this.props.dispatch(fetchPosts());
    this.redirect = setTimeout(
      () => this.setState({ redirect: true }),
      5000
    );
  }
  componentWillUnmount() {
    clearTimeout(this.redirect);
  }

  render() {
    const { error, filtered } = this.props;
    const post = this.props.post ? (
      <div className="post">
        <Helmet>
          <title>STech - {this.props.post.title}</title>
          <meta name="description" content={this.props.post.description} />
          <meta property="og:title" content={this.props.post.title} />
          <meta
            property="og:description"
            content={this.props.post.description}
          />
        </Helmet>
        <div className="title">
          <h1 dangerouslySetInnerHTML={{ __html: this.props.post.title }} />
          <h4>{new Date(this.props.post.date).toDateString()}</h4>
        </div>
        <div className="image">
            <img src={this.props.post.image} alt={this.props.post.title} />
        </div>
        <div className="body">
          <Markdown>{this.props.post.body}</Markdown>
          <span className="share">Share on</span>
        </div>
        <div className="socials">
          <FacebookShareButton
            url={"https://www.stech.com/post/" + this.props.post.newsId}
            quote={this.props.post.title}
            className="Demo__some-network__share-button">
            <FacebookIcon
              size={32}
              round />
          </FacebookShareButton>

          <TwitterShareButton
            url={"https://www.stech.com/post/" + this.props.post.newsId}
            title={this.props.post.title}>
            <TwitterIcon
              size={32}
              round />
          </TwitterShareButton>

          <WhatsappShareButton
            url={"https://www.stech.com/post/" + this.props.post.newsId}
            title={this.props.post.title}
            windowWidth={600}
            windowHeight={700}
            separator=": ">              
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>

          <LinkedinShareButton
            url={"https://www.stech.com/post/" + this.props.post.newsId}
            windowWidth={750}
            windowHeight={600}>
            <LinkedinIcon
              size={32}
              round />
          </LinkedinShareButton>
        </div>
      </div>
    ) : (
      <div className="sub-page fadeInUp minHeight250">
        <section className="clearfix">
          <div className="container">
            <div className="center">Loading...</div>
          </div>
        </section>
      </div>
    );
    if (filtered == null || error) {
      return this.state.redirect
        ? <Redirect to="/news" />
        : (
          <div className="sub-page fadeInUp minHeight250">
            <section className="clearfix">
              <div className="container">
                <div className="center"><img src={loader} alt="Loading..." /></div>
              </div>
            </section>
          </div>
      );
    }
    return (
      <div className="sub-page">
        <section className="clearfix fadeIn">
          <div className="container">{post}</div>
          <div className="container">
            <Link to="/news">
              <span className="postButton">← Back to news</span>
            </Link>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let id = ownProps.match.params.post_id;
  return {
    post: state.posts.items.find(post => post.newsId === id),
    error: state.posts.error,
    filtered: state.posts.items.find(post => post.newsId === id)
  };
}

export default connect(mapStateToProps)(Post)
